import request from '@/utils/request'
import qs from 'qs'

// export function getListDailyReport(query) {
//   return request({
//     url: '/report-service/v1/report/daily-report',
//     method: 'get',
//     params: query,
//     paramsSerializer: query => {
//       return qs.stringify(query, {
//         arrayFormat: 'repeat',
//         encode: false
//       })
//     }
//   })
// }

// report 29
export function getCreateCardRoomReport(query) {
  return request({
    url: '/card-service/v1/card-room',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}

export function getCreateCardRoomReportExcel(query) {
  return request({
    url: '/card-service/v1/card-room/list-excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'arraybuffer'
  })
}

// report 30,31
export function getLockRecordUseReport(query) {
  return request({
    url: '/card-service/v1/lock-record',
    method: 'get',
    params: query
  })
}

export function getLockRecordUseReportExcel(query) {
  return request({
    url: '/card-service/v1/lock-record/excel',
    method: 'get',
    params: query,
    responseType: 'arraybuffer'
  })
}

// report 45
export function getUpdateInvoiceReport(query) {
  return request({
    url: '/report-service/v1/invoice-report/update-invoice',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}
export function getUpdateInvoiceReportExcel(query) {
  return request({
    url: '/report-service/v1/invoice-report/update-invoice/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'blob'
  })
}
// report 47
export function getTransactionSummaryReport(query) {
  return request({
    url: '/report-service/v1/invoice-report/transaction-summary',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}
export function getTransactionSummaryReportExcel(query) {
  return request({
    url: '/report-service/v1/invoice-report/transaction-summary/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'blob'
  })
}
// report 48
export function getBookAndServiceReport(query) {
  return request({
    url: '/report-service/v1/book-and-service-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}
export function getBookAndServiceReportExcel(query) {
  return request({
    url: '/report-service/v1/book-and-service-report/export-excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'blob'
  })
}

// report 49
export function getCashReport(query) {
  return request({
    url: '/report-service/v1/invoice-report/cash',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}
export function getCashReportExcel(query) {
  return request({
    url: '/report-service/v1/invoice-report/cash/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'blob'
  })
}
// report 50
export function getCompareAccountReport(query) {
  return request({
    url: '/report-service/v1/compare-account-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}
export function getCompareAccountReportExcel(query) {
  return request({
    url: '/report-service/v1/compare-account-report/list-excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'blob'
  })
}

// report 51
export function getRevenueReport(query) {
  return request({
    url: '/report-service/v1/invoice-report/revenue',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}
export function getRevenueReportExcel(query) {
  return request({
    url: '/report-service/v1/invoice-report/revenue/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'blob'
  })
}
// report 52
export function getDetailRevenueReport(query) {
  return request({
    url: '/report-service/v1/invoice-report/detail-revenue',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}
export function getDetailRevenueReportExcel(query) {
  return request({
    url: '/report-service/v1/invoice-report/detail-revenue/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'blob'
  })
}
export function getSubServiceTransaction() {
  return request({
    url: '/config-service/v1/transaction/sub-transaction/',
    method: 'get',
    params: {
      transactionGroup: 1 // only service sub transaction
    }
    // paramsSerializer: query => {
    //   return qs.stringify(query, {
    //     arrayFormat: 'repeat',
    //     encode: false,
    //     skipNulls: true
    //   })
    // }
  })
}

// report 53
export function getRoomOccupiedChart(query) {
  return request({
    url: '/report-service/v1/occupied-room-level-report/room-occupied-chart',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}

// report 58
export function getDebtReport(query) {
  return request({
    url: '/report-service/v1/debt-report',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}
export function getDebtReportExcel(query) {
  return request({
    url: '/report-service/v1/debt-report/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'blob'
  })
}
export function getGrowthChart(query) {
  return request({
    url: '/report-service/v1/debt-report/growth-chart',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}

// report 59
export function getTransactionCodeApi() {
  return request({
    url: '/config-ticket-service/v1/debt-account-payment/transaction-code',
    method: 'get'
  })
}
export function getDebtDetailReport(query) {
  return request({
    url: '/report-service/v1/debt-report/detail',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}
export function getDebtDetailReportExcel(query) {
  return request({
    url: '/report-service/v1/debt-report/detail/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'blob'
  })
}
export function paymentDebAccount(data) {
  return request({
    url: '/config-ticket-service/v1/debt-account-payment',
    method: 'post',
    data
  })
}

// report 60
export function getInvoiceReport(query) {
  return request({
    url: '/report-service/v1/invoice-report/invoice',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}
export function getInvoiceReportExcel(query) {
  return request({
    url: '/report-service/v1/invoice-report/invoice/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'blob'
  })
}
// report 62
export function getKeepCancelRoomReport(query) {
  return request({
    url: '/report-service/v1/report/keep-cancel-room',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}
// report han muc
export function getLimitReportApi(query) {
  return request({
    url: '/report-service/v1/report/limit',
    method: 'get',
    params: query
  })
}
